import { render, staticRenderFns } from "./SectionBlockBanner.vue?vue&type=template&id=17f44c72&scoped=true&"
import script from "./SectionBlockBanner.vue?vue&type=script&lang=ts&"
export * from "./SectionBlockBanner.vue?vue&type=script&lang=ts&"
import style0 from "./SectionBlockBanner.vue?vue&type=style&index=0&id=17f44c72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f44c72",
  null
  
)

export default component.exports